import React from 'react';
import { FiInbox } from 'react-icons/fi';

export default function EmptyState({ title = 'No records found', message = 'There is nothing here yet.' }) {
  return (
    <div className="empty-state">
      <div className="e-icon">
        <FiInbox />
      </div>
      <h4>{title}</h4>
      <p>{message}</p>
    </div>
  );
}